export const colors = {
    red: '#b6332b',
    blue: '#13293d',
    green: '#34d57d',
}